import { AUTHORITY, CHANGE_REQUEST_TYPE, IS_ALLOW_VALIDATE, MAINTENANCE, ORGANIZATION, STORE_CODE } from './type';
import { AdminRequest } from '../../services';

export const setStoreCode = (data = '') => {
    return {
        type: STORE_CODE,
        data: data,
    };
};

export const setOrganization = (data = AdminRequest.organization) => {
    return {
        type: ORGANIZATION,
        data: data,
    };
};

export const setAuthority = (data = AdminRequest.authority) => {
    return {
        type: AUTHORITY,
        data: data,
    };
};

export const setChangeRequestType = (data = '') => {
    return {
        type: CHANGE_REQUEST_TYPE,
        data: data,
    };
};

export const setMaintenance = (data = false) => {
    return {
        type: MAINTENANCE,
        data: data,
    };
};

export const setIsAllowValidate = (data = false) => {
    return {
        type: IS_ALLOW_VALIDATE,
        data: data,
    };
};
